import React, { useState, useEffect } from "react";
import { Navbar, Container, Nav } from "react-bootstrap";
import { Link } from "react-router-dom";
import logo from "../../assets/images/my_logo4.png";

function AppNavbar() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 200) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <div>
      {/* Mobile & Tablet Navbar */}
      <div className="d-lg-none">
        <Navbar
          bg="light"
          expand="lg"
          fixed="top"
          style={{ boxShadow: "0 2px 4px rgba(0,0,0,0.08)" }}
        >
          <Container>
            <Navbar.Brand as={Link} to="/">
              <img
                src={logo}
                alt="Logo"
                style={{ height: "40px" }}
                className="img-fluid"
              />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="basic-navbar-nav" />

            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link as={Link} to="/" style={{ color: "#222" }}>
                  Home
                </Nav.Link>
                <Nav.Link as={Link} to="/sports" style={{ color: "#222" }}>
                  Sports
                </Nav.Link>
                <Nav.Link as={Link} to="/health" style={{ color: "#222" }}>
                  Health
                </Nav.Link>
                <Nav.Link as={Link} to="/technology" style={{ color: "#222" }}>
                  Technology
                </Nav.Link>
                <Nav.Link as={Link} to="/Auto" style={{ color: "#222" }}>
                  Auto
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/entertainment"
                  style={{ color: "#222" }}
                >
                  Entertainment
                </Nav.Link>
                <Nav.Link as={Link} to="/immigration" style={{ color: "#222" }}>
                  Immigration
                </Nav.Link>
                <Nav.Link as={Link} to="/heritage" style={{ color: "#222" }}>
                  Hertiage
                </Nav.Link>
                <Nav.Link as={Link} to="/travel" style={{ color: "#222" }}>
                  Travel
                </Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
        <div style={{ marginTop: "70px" }}></div>
      </div>

      {/* Desktop Navbar - Three Lines */}
      <div className="d-none d-lg-block">
        {/* Line 1: Top Info Bar */}
        <div
          style={{
            background: "#f8f9fa",
            borderBottom: "1px solid #e0e0e0",
            padding: "10px 0",
            fontSize: "13px",
          }}
        >
          <Container fluid>
            <div className="d-flex justify-content-between align-items-center">
              <div style={{ color: "#666" }}>
                {new Date().toLocaleDateString("en-US", {
                  weekday: "long",
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                })}
              </div>
            </div>
          </Container>
        </div>

        {/* Line 2: Logo */}
        <div
          style={{
            padding: "25px 0",
            background: "#fff",
            borderBottom: "1px solid #e0e0e0",
          }}
        >
          <Container>
            <div className="text-center">
              <Link to="/">
                <img
                  src={logo}
                  alt="Logo"
                  style={{ height: "80px" }}
                  className="img-fluid"
                />
              </Link>
            </div>
          </Container>
        </div>

        {/* Line 3: Main Navigation */}
        <Navbar
          bg="white"
          style={{
            borderTop: "0.2px solid #bed7fdff",
            borderBottom: "0.2px solid #e0e0e0",
            boxShadow: "0 2px 4px rgba(0,0,0,0.05)",
          }}
        >
          <Container>
            <Nav className="mx-auto">
              <Nav.Link
                as={Link}
                to="/"
                className="px-3 fw-semibold"
                style={{ color: "#222" }}
              >
                Home
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/sports"
                className="px-3 fw-semibold"
                style={{ color: "#222" }}
              >
                Sports
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/auto"
                className="px-3 fw-semibold"
                style={{ color: "#222" }}
              >
                Auto
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/technology"
                className="px-3 fw-semibold"
                style={{ color: "#222" }}
              >
                Technology
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/entertainment"
                className="px-3 fw-semibold"
                style={{ color: "#222" }}
              >
                Entertainment
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/health"
                className="px-3 fw-semibold"
                style={{ color: "#222" }}
              >
                Health
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/immigration"
                className="px-3 fw-semibold"
                style={{ color: "#222" }}
              >
                Immigration
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/heritage"
                className="px-3 fw-semibold"
                style={{ color: "#222" }}
              >
                Heritage
              </Nav.Link>
              <Nav.Link
                as={Link}
                to="/travel"
                className="px-3 fw-semibold"
                style={{ color: "#222" }}
              >
                Travel
              </Nav.Link>
            </Nav>
          </Container>
        </Navbar>

        {/* Sticky Navbar on Scroll */}
        {scrolled && (
          <Navbar
            bg="white"
            fixed="top"
            style={{
              boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
              borderBottom: "0.2px solid #0066ff",
            }}
          >
            <Container>
              <Navbar.Brand as={Link} to="/">
                <img
                  src={logo}
                  alt="Logo"
                  style={{ height: "35px" }}
                  className="img-fluid"
                />
              </Navbar.Brand>
              <Nav className="ms-auto">
                <Nav.Link
                  as={Link}
                  to="/"
                  className="px-3"
                  style={{ color: "#222" }}
                >
                  Home
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/sports"
                  className="px-3"
                  style={{ color: "#222" }}
                >
                  Sports
                </Nav.Link>

                <Nav.Link
                  as={Link}
                  to="/technology"
                  className="px-3"
                  style={{ color: "#222" }}
                >
                  Technology
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/auto"
                  className="px-3"
                  style={{ color: "#222" }}
                >
                  Auto
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/health"
                  className="px-3"
                  style={{ color: "#222" }}
                >
                  Health
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/entertainment"
                  className="px-3"
                  style={{ color: "#222" }}
                >
                  Entertainment
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/immigration"
                  className="px-3"
                  style={{ color: "#222" }}
                >
                  Immigration
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/heritage"
                  className="px-3"
                  style={{ color: "#222" }}
                >
                  Heritage
                </Nav.Link>
                <Nav.Link
                  as={Link}
                  to="/travel"
                  className="px-3"
                  style={{ color: "#222" }}
                >
                  Travel
                </Nav.Link>
              </Nav>
            </Container>
          </Navbar>
        )}
      </div>
    </div>
  );
}

export default AppNavbar;
